<template>
    <nav :class="['navbar navbar-expand-md navbar-light', {'is-sticky': isSticky}]">

        <router-link class="navbar-brand" to="/">
            <img src="../../assets/img/jill_icon_n.png" alt="Logo">
        </router-link>

        <div 
            class="navbar-toggler" 
            @click="toggleMenu"
            :aria-pressed="active ? 'true' : 'false'"
            :class="{ 'active': button_active_state }"
        >
            <i class='bx bx-menu'></i>
            <i class='bx bx-x'></i>
        </div>

        <div class="collapse navbar-collapse" :class="{ toggler: active }">
            <ul class="navbar-nav">

                <li class="nav-item">
                    <a class="nav-link" href="/">
                        {{ $t('nav2.home') }}
                    </a>
                </li>  
                
                <li class="nav-item">
                    <a class="nav-link" href="/#service">
                        {{ $t('nav2.services') }}
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" href="/#service-multiple">
                        {{ $t('nav2.web') }}
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" href="/#maintenance">
                        {{ $t('nav2.ads') }}
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" href="/#contact-strip">
                        {{ $t('nav2.contact') }}
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" href="/#aboutus">
                        {{ $t('nav2.about') }}
                    </a>
                </li>

                <!-- 🌍 SELECTOR DE IDIOMA -->
                <li class="nav-item lang-switch">
                    <img 
                        src="https://flagcdn.com/w40/es.png" 
                        alt="ES"
                        @click="changeLang('es')"
                        :class="{ active: $i18n.locale === 'es' }"
                    />
                    <img 
                        src="https://flagcdn.com/w40/gb.png" 
                        alt="EN"
                        @click="changeLang('en')"
                        :class="{ active: $i18n.locale === 'en' }"
                    />
                </li>

            </ul>
        </div>

    </nav>
</template>

<script>
export default {
    name: 'NavbarTwo',
    data(){
        return {
            isSticky: false,
            active: false,
            button_active_state: false
        }
    },
    mounted(){
        window.addEventListener('scroll', () => {
            this.isSticky = window.scrollY >= 100
        })
    },
    methods: {
        toggleMenu() {
            this.active = !this.active
            this.button_active_state = !this.button_active_state
        },
        changeLang(lang) {
            this.$i18n.locale = lang
            localStorage.setItem('lang', lang)
        }
    }
}
</script>

<style scoped>
/* ====== FLAGS ====== */
.lang-switch {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 15px;
}
.navbar-toggler {
  color: #e8e7e7 !important;
  border: none;
}

.lang-switch img {
    width: 22px;
    height: 16px;
    cursor: pointer;
    border-radius: 2px;
    opacity: 0.7;
    transition: 0.2s;
}

.lang-switch img:hover {
    opacity: 1;
    transform: scale(1.1);
}

.lang-switch img.active {
    opacity: 1;
    outline: 2px solid #d35400;
}
</style>